export let Scene = null;
export let LayerManager = null;
export let store = null;
// tady bych tedy radeji videl jednotlive exportovane funkce kvuli typum a taky moznosti neimportovat vsechno

export function setGlobals(global) {
	Scene = global.Scene;
	LayerManager = global.LayerManager;
	store = global.store;
}
